import firebase from "@firebase/app"
import * as firebaseui from "firebaseui"

export const firebaseUiConfig = {
  signInFlow: 'popup',
  signInOptions: [
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    //firebase.auth.GithubAuthProvider.PROVIDER_ID,
  ],
  credentialHelper: firebaseui.auth.CredentialHelper.NONE,
  // signInSuccessUrl: 'http://localhost:8080/#loginSuccess',
  callbacks: {
    signInSuccessWithAuthResult: function(authResult, redirectUrl) {
      window.localStorage.setItem('isNewUser', authResult.additionalUserInfo.isNewUser)
      window.localStorage.setItem('providerId', authResult.additionalUserInfo.providerId)
      return false
    },
    signInFailure: function(error) {
      console.log(error)
    },
    uiShown: function() {
    }
  },
}
